// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2963":"b0c9606abeb53157","5231":"6f5ad811e3c2be79","5351":"89da53437c919fd3","9851":"5fde78187e32ebb7"}[chunkId] + ".css";
};